import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=3d1f19f8&"
import script from "./ResourceTable.vue?vue&type=script&lang=ts&"
export * from "./ResourceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports